import { createFileRoute } from "@tanstack/react-router";

import { StrictOpportunityId } from "@goose/schema/Salesforce";

export const Route = createFileRoute(
  "/_authenticated/opportunity/$opportunityId",
)({
  params: {
    parse: ({ opportunityId }) => {
      return {
        opportunityId: StrictOpportunityId.parse(opportunityId),
      };
    },
  },
});
